import React from 'react';

export const UserIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="26"
    height="27"
    viewBox="0 0 26 27"
    fill="none"
  >
    <rect y="0.5" width="26" height="26" rx="8" fill="#F7FAFD" />
    <path
      d="M18.7507 15.4953C19.9927 15.4953 20.9995 16.5021 20.9995 17.7442V18.6626C20.9995 19.236 20.8203 19.795 20.4869 20.2615C18.9411 22.4247 16.4168 23.4964 12.9965 23.4964C9.57549 23.4964 7.05253 22.4243 5.51037 20.2599C5.1784 19.794 5 19.2362 5 18.6641V17.7442C5 16.5021 6.00685 15.4953 7.24887 15.4953H18.7507ZM12.9965 3.5C15.7579 3.5 17.9965 5.73858 17.9965 8.5C17.9965 11.2614 15.7579 13.5 12.9965 13.5C10.235 13.5 7.99646 11.2614 7.99646 8.5C7.99646 5.73858 10.235 3.5 12.9965 3.5Z"
      fill="#27B0E0"
    />
  </svg>
);
